
import {
  Box,
  CircularProgress,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import QuickSightDashboard from "../components/dataPage/components/QuickSightDashboard";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

function DataPage() {
  const [currentDate, setCurrentDate] = useState<number>(25);
  const [currentShift, setCurrentShift] = useState<string>("A");
  const [dataDisplay, setDataDisplay] = useState<string | null>(
    "environmental"
  );

  const [embedUrl, setEmbedUrl] = useState("");

  const handleDataDisplay = (
    event: React.MouseEvent<HTMLElement>,
    newDisplay: string | null
  ) => {
    setDataDisplay(newDisplay);
  };

  const capitalizeWord = (word: string) => {
    return word.replace(/\b\w/g, function (char: string) {
      return char.toUpperCase();
    });
  };

  useEffect(() => {
    const fetchDashboard = async () => {
      const token = localStorage.getItem("jwt");
      // let response = await axios.get("http://18.232.163.40:4000/quicksight-url", 
      // let response = await axios.get("https://localhost:4000/quicksight-url", 
      let response = await axios.get(`${apiUrl}/quicksight-url`, 
        {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("Embed Url:", response.data.embedUrl);
      setEmbedUrl(response.data.embedUrl);
    };

    fetchDashboard();
  }, []);

  return (
    <>
      {embedUrl ? (
        <QuickSightDashboard embedUrl={embedUrl} />
      ) : (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
        >
          <CircularProgress />
        </Box>
      )}
     
    </>
  );
}

export default DataPage;
